import IconButtonComponent from '../../Basic/IconButton/IconButton.mjs';
import styled from 'styled-components';

const SearchButton = styled(IconButtonComponent) `
  svg {
    margin-right: 2px;
    margin-top: 1px;
  }
`;
const StyledForm = styled.form `
  position: relative;
  top: -4px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: none;
  border-bottom: 1px solid ${props => props.theme.colors.darkGray}80;

  @media (pointer: fine) {
    &:hover {
      border-bottom: 1px solid ${props => props.theme.colors.darkGray};
    }
  }

  &:focus {
    border-bottom: 1px solid ${props => props.theme.colors.darkGray};
  }
`;
const StyledSearchField = styled.input `
  border: none;
  background: transparent;
  color: ${props => props.theme.colors.textColor};
  font-size: ${props => props.theme.typography.text.tiny.fontSize};
  font-weight: ${props => props.theme.typography.fontWeight.regular};
  line-height: ${props => props.theme.typography.text.tiny.lineHeight};
  padding: 11px 0;
  width: 100%;

  &::placeholder {
    color: ${props => props.theme.colors.mutedTextColor};
  }

  &:focus {
    outline: none;

    &::placeholder {
      color: transparent;
    }
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 7px 0 11px;
  }
`;

export { SearchButton, StyledForm, StyledSearchField };
//# sourceMappingURL=Search.styles.mjs.map
